/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarStacked100H = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-bar-stacked-100-h_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-chart-bar-stacked-100-h_svg__st0"
      d="M4 18h6v-2H4v-2h9v-2H4v-2h5V8H4V6h7V4H4V2H2v20h20v-2H4z"
    />
    <path
      className="ico-chart-bar-stacked-100-h_svg__st0"
      d="M12 4h4v2h-4zm5 0h5v2h-5zm-3 8h8v2h-8zm-4-4h12v2H10zm1 8h8v2h-8zm9 0h2v2h-2z"
    />
  </Icon>
);
export { SvgChartBarStacked100H as ChartBarStacked100H };
